var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M200,35.07h-106.01c-32.54,0-58.93,26.39-58.93,58.94v106c0,45.55,18.46,86.78,48.31,116.62,29.85,29.85,71.08,48.31,116.63,48.31s86.78-18.46,116.62-48.31c29.85-29.84,48.31-71.07,48.31-116.62,0-91.09-73.84-164.94-164.93-164.94ZM194.35,214.32c7.91,0,14.32-6.41,14.32-14.32s-6.41-14.31-14.32-14.31v-18.88c18.34,0,33.2,14.86,33.2,33.19s-14.86,33.2-33.2,33.2v-18.88ZM194.35,329.63v-73.75c30.87,0,55.89-25.02,55.89-55.89s-25.02-55.88-55.89-55.88v-73.75c71.6,0,129.64,58.04,129.64,129.63s-58.04,129.64-129.64,129.64Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ea3a1910dc69f0ff2cd5a96313dbcc51.svg";
export { ForwardRef as ReactComponent };